import { Card, CardHeader, CardContent, Typography, Grid } from "@mui/material";
import React from "react";
import GroupHeader from "./home/header";
import SubCategoriesHeader from "./home/header";
import GroupTabel from "./home/table";
import SubCategoriesTabel from "./home/table";

const Group = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <GroupHeader />
      </Grid>
      <Grid item xs={12}>
        <GroupTabel />
      </Grid>
    </Grid>
  );
};

export default Group;
